import React from "react";
import { Route, Routes } from "react-router-dom";

import IndexExpenseTypes from "./setting/expenseType/IndexExpenseTypes";
import IndexCompanyExpenses from "./companyExpenses/IndexCompanyExpenses";
import IndexExpenseApprovals from "./expenseApprovals/IndexExpenseApprovals";
import IndexMyExpenses from "./myExpenses/IndexMyExpenses";
import { guardElement } from "@comps/components";


const ExpenseModules = () => {
  return (
    <Routes>
      <Route path="settings/types" element={ guardElement(<IndexExpenseTypes modkey="expenseTypes"/>, "expenseTypes") } />
      <Route path="company-requests" element={ guardElement(<IndexCompanyExpenses modkey="companyExpenses"/>, "companyExpenses") } />
      <Route path="requests" element={ guardElement(<IndexMyExpenses modkey="expenseRequests"/>, "expenseRequests") } />
      <Route path="approvals" element={ guardElement(<IndexExpenseApprovals api='expenseApprovals' modkey="expenseApprovals"/>, "expenseApprovals") } />
      <Route path="delegates" element={ guardElement(<IndexExpenseApprovals api='expenseDelegates' modkey="expenseDelegates"/>, "expenseDelegates") } />
    </Routes>
  );
}

export default ExpenseModules;
